/**
 * Client for /api/search/suggest (B-117, 2026-06-18).
 *
 *   suggestGhost(prefix) — autocomplete (called per-keystroke, debounced)
 *
 * Network / non-2xx / parse failures resolve to `null` rather than
 * throw so the surrounding UI never breaks because of a suggestion
 * outage. The did-you-mean banner was removed by user direction
 * 2026-06-18; only the ghost-text autocomplete remains.
 */

import { getInternalAuthHeaders } from "./internal-headers";

function apiBaseUrl(): string {
  if (typeof window === "undefined") {
    return process.env.API_INTERNAL_URL ?? process.env.API_URL ?? "http://localhost:8000";
  }
  return process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8000";
}

export async function suggestGhost(
  prefix: string,
  countryCode = "AU",
  signal?: AbortSignal,
): Promise<string | null> {
  const q = (prefix ?? "").trim();
  if (q.length < 3) return null;
  const url = `${apiBaseUrl()}/api/search/suggest?q=${encodeURIComponent(q)}&country_code=${encodeURIComponent(countryCode)}`;
  try {
    const r = await fetch(url, {
      method: "GET",
      headers: { Accept: "application/json", ...getInternalAuthHeaders() },
      signal,
      cache: "no-store",
    });
    if (!r.ok) return null;
    const body = (await r.json()) as { canonical: string | null };
    return body.canonical ?? null;
  } catch {
    return null;
  }
}

